import { objectFromEntries } from "@raven/shared/utils";

export const sumArray: (arr: any[]) => number = arr =>
  arr.reduce(
    (acc, cur) => (cur && isFinite(Number(+cur)) ? +acc + +cur : acc),
    0
  );
export const array_max = arr =>
  arr.reduce((max, cur) => (+max > +cur ? +max : +cur), 0);

export const filterObjectByKeepingKeys = (
  object: Record<string, unknown>,
  keysToKeep: string[]
) =>
  objectFromEntries(
    Object.entries(object).filter(([key]) => keysToKeep.includes(key))
  );
export const filterObjectByRemovingKeys = (
  object: Record<string, unknown>,
  keysToRemove: string[]
) =>
  objectFromEntries(
    Object.entries(object).filter(([key]) => !keysToRemove.includes(key))
  );

export const removeKeysFromObject = (
  object: Record<string, unknown>,
  keysToRemove: string[]
) =>
  objectFromEntries(
    Object.entries(object).filter(([key]) => !keysToRemove.includes(key))
  );

export const mapObjectValues = (
  object: Record<string, unknown>,
  mapFn: (item: any) => any
) =>
  objectFromEntries(
    Object.entries(object).map(([key, val]) => [key, mapFn(val)])
  );
